import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
import Label from './Label';
import ErrorLabel from './ErrorLabel';
const Radio = ({ id, name, value, label, children, checked, helptext, onChange, disabled, className, error, style, hideLabel, info, }) => {
    function handleChange(e) {
        onChange(e.target.value);
    }
    let body;
    if (label) {
        body = label;
    }
    else if (children) {
        body = children;
    }
    function renderErrorMessage() {
        if (!(error && error.message)) {
            return null;
        }
        return React.createElement(ErrorLabel, { className: "mt-1 mb-4" }, error.message);
    }
    const hasLabel = !hideLabel && body;
    const containerClassName = getClassName('relative', {
        flex: hasLabel,
        'items-start': hasLabel,
    }, className);
    const labelClassName = getClassName({
        'ml-3': hasLabel,
        'text-sm': hasLabel,
    });
    return (React.createElement("div", { className: containerClassName, style: style },
        React.createElement("div", { className: "flex items-center h-5" },
            React.createElement("input", { id: id, type: "radio", name: name, value: value, checked: checked, disabled: disabled, onChange: handleChange, className: "w-4 h-4 border-gray-200 border-solid rounded text-green focus:ring-green" })),
        (hasLabel || helptext) && (React.createElement("div", { className: labelClassName },
            body && (React.createElement(Label, { htmlFor: id, helptext: info, className: "font-medium text-gray-700" }, body)),
            helptext && helptext())),
        renderErrorMessage()));
};
Radio.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    hideLabel: PropTypes.bool,
    label: PropTypes.string,
    children: PropTypes.any,
    helptext: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    error: PropTypes.object,
};
Radio.defaultProps = {
    hideLabel: false,
    checked: false,
    disabled: false,
    error: {},
};
export default Radio;
